module.exports = __webpack_public_path__ + "img/star_b.4638107a.png";